import toast from 'react-hot-toast';

import { draftApi } from 'src/api/draftApi';
import { queryApi } from 'src/api/queryApi';
import { markAsStarted, updateProgress, removeFromQueue } from 'src/store/slices/queueSlice';

// Helper function to add delay between retries
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const processQueue = async (queue, dispatch) => {
  const processingTasks = queue.map(async (item) => {
    if (!item.isStarted) {
      dispatch(markAsStarted({ queryID: item.queryID }));

      let retryCount = 0;
      const maxRetries = 3;

      while (retryCount < maxRetries) {
        try {
          // Finding experts
          dispatch(updateProgress({ queryID: item.queryID, step: 'findingExperts', progress: 10 }));

          const response = await draftApi.find2Experts(item.queryID);
          console.log('response', response);
          const expertsData = response;
          const expertIds = expertsData.split(',').map((id) => id.trim());
          console.log('expertIds', expertIds);

          dispatch(updateProgress({ queryID: item.queryID, step: 'findingExperts', progress: 30 }));

          // Generating emails
          dispatch(updateProgress({ queryID: item.queryID, step: 'generatingEmails', progress: 40 }));

          const totalExperts = expertIds.length;
          let completedExperts = 0;

          const expertPromises = expertIds.map(async (expertId) => {
            await draftApi.generateInitialEmail(item.queryID, expertId);

            completedExperts++;
            const progress = 40 + Math.floor((completedExperts / totalExperts) * 50);
            dispatch(updateProgress({ queryID: item.queryID, step: 'generatingEmails', progress }));
          });

          await Promise.all(expertPromises);

          dispatch(updateProgress({ queryID: item.queryID, step: 'completed', progress: 100 }));
          dispatch(removeFromQueue({ queryID: item.queryID }));

          // Success - break out of retry loop
          break;
        } catch (error) {
          retryCount++;

          if (retryCount < maxRetries) {
            // Still have retries left
            const retryMessage = `Attempt ${retryCount} failed, retrying... (${maxRetries - retryCount} attempts remaining)`;
            toast.error(retryMessage);

            // Wait before retrying (exponential backoff: 1s, 2s, 4s)
            const delayMs = Math.pow(2, retryCount - 1) * 1000;
            await delay(delayMs);

            // Reset progress for retry
            dispatch(updateProgress({ queryID: item.queryID, step: 'retrying', progress: 5 }));
          } else {
            // All retries exhausted
            toast.error(`Failed to process queue item after ${maxRetries} attempts: ${error.message}`);

            // Discard the query since it failed after all retries
            try {
              await queryApi.updateQuery(item.queryID, 'discarded');

              // Update queue item status to discarded before removing
              dispatch(updateProgress({ queryID: item.queryID, step: 'discarded', progress: 0 }));

              // Remove the discarded item from the queue
              dispatch(removeFromQueue({ queryID: item.queryID }));

              toast.error('Query has been discarded due to repeated failures');
            } catch (discardError) {
              // Even if discard API fails, still update the queue status
              dispatch(updateProgress({ queryID: item.queryID, step: 'error', progress: 0 }));
            }
          }
        }
      }
    }
  });

  await Promise.all(processingTasks);
};
